import { useCallback } from 'react'

import { useOpenWindow } from '@krp/client-runtime'
import { PLATFORM_WINDOWS, type OpenCommonProduct, type ProductPhotoUrl } from '@krp/platform-ui'

import { PRODUCT_PHOTO_URLS } from '../../composition/connectionForms'

/** Фото найденного товара из источника — адресом пакета вида его карточки; вид без фото или удалённая карточка — `null`. */
export const productPhotoUrl: ProductPhotoUrl = (ref) =>
  ref.state === 'deleted' ? null : PRODUCT_PHOTO_URLS[ref.resourceKind]?.(ref.resourceId, ref.remoteKey) ?? null

/**
 * Единственное место, где решается, какая карточка открывается у товара, найденного в ОБЩЕМ каталоге (решение владельца 24.10.2026):
 * поиск по фото и сканер — всегда окно «Общий товар» (`platform.common-product`) поверх того, откуда открыли; закрыли
 * карточку — человек там же, со сканером и выдачей. Карточка источника (1С, AQSI, своя база) открывается только из вкладки
 * самого источника, и этот хук её не знает.
 */
export function useOpenCommonProduct(): OpenCommonProduct {
  const openWindow = useOpenWindow()
  return useCallback<OpenCommonProduct>((productId) => openWindow(PLATFORM_WINDOWS.commonProduct, { productId }), [openWindow])
}
